
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 2A14.041 14.041 0 004 16l17.737 3.737z","fill":"#ed6c47"}}),_c('path',{attrs:{"d":"M18.01 2A14.033 14.033 0 0132 16l-7 4.758L18.01 16z","fill":"#ff8f6b"}}),_c('path',{attrs:{"d":"M18 30a14.041 14.041 0 0014-14H4a14.041 14.041 0 0014 14z","fill":"#d35230"}}),_c('path',{attrs:{"d":"M16.666 7H7.305a13.915 13.915 0 00.931 19h8.43A1.337 1.337 0 0018 24.667V8.333A1.337 1.337 0 0016.666 7z","opacity":".1"}}),_c('path',{attrs:{"d":"M15.666 8H6.539a13.907 13.907 0 002.845 19h6.282A1.337 1.337 0 0017 25.667V9.333A1.337 1.337 0 0015.666 8z","opacity":".2"}}),_c('path',{attrs:{"d":"M15.666 8H6.539a13.891 13.891 0 00.766 17h8.361A1.337 1.337 0 0017 23.667V9.333A1.337 1.337 0 0015.666 8z","opacity":".2"}}),_c('path',{attrs:{"d":"M14.666 8H6.539a13.891 13.891 0 00.766 17h7.361A1.337 1.337 0 0016 23.667V9.333A1.337 1.337 0 0014.666 8z","opacity":".2"}}),_c('rect',{attrs:{"y":"8","width":"16","height":"16","rx":"1.333","fill":"#c43e1c"}}),_c('path',{attrs:{"d":"M8.035 11a4.163 4.163 0 012.752.8 2.878 2.878 0 01.955 2.329 2.729 2.729 0 01-.472 1.586A3.165 3.165 0 019.927 16.9a4.567 4.567 0 01-2.018.423H6v3.667H4.042V11zM6 15.678h1.685a2.192 2.192 0 001.49-.444 1.1 1.1 0 00.5-1.024q0-1.658-1.931-1.657H6z","fill":"#f9f7f7"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h32v32H0z"}})])
          )
        }
      }
    